import { SplitTreatments } from "@splitsoftware/splitio-react";
import BenefitCard from "../BenefitCard";
import { BenefitTypeEnum } from "../../../../v2/domain/common/entities/BenefitType";
import alternateCountryTranslations from "../../../../infrastructure/translate/alternateCountyTranslations";
import healthInsuranceBenefitImageV2 from "../../../../assets/img/v2/health-insurance-benefit.png";
import healthInsuranceBenefitDisabledImageV2 from "../../../../assets/img/v2/health-insurance-benefit-disabled.png";
import { displayHealthInsuranceModal } from "../../../../usecases/benefit-model/displays/display-health-insurances-modal";
import { CountryIsoCode } from "../../../../v2/domain/common/enums/CountryISOCode";
import featureFlagsDictionary from "../../../../infrastructure/split/feature-flags-dictionary";
import { BenefitCategory } from "../../../../v2/domain/common/entities/BenefitCagetory";

const HealthInsuranceCard = ({
  insuranceProducts = [],
  country,
  selectedEmployeeGroup,
  toggleActive,
}: {
  insuranceProducts: Record<string, unknown>[];
  country: CountryIsoCode;
  selectedEmployeeGroup: {
    id: string;
    healthInsuranceBenefit: boolean;
  };
  toggleActive: (
    id: string,
    benefit: string,
    isV2?: boolean,
    state?: boolean
  ) => void;
}) => {
  const image =
    insuranceProducts.length === 0 ||
    !selectedEmployeeGroup.healthInsuranceBenefit
      ? healthInsuranceBenefitDisabledImageV2
      : healthInsuranceBenefitImageV2;

  const buildCardProps = () => {
    const cardProps = {
      image,
      benefit: BenefitTypeEnum.HEALTH_INSURANCE_BENEFIT,
      title: alternateCountryTranslations(country, "health-insurance"),
      country,
      handleSeeMore: () => {},
      requestInfo: false,
      active: selectedEmployeeGroup.healthInsuranceBenefit,
      tooltipText: alternateCountryTranslations(
        country,
        "health-insurance-tooltip"
      ),
      handleAdvance: () =>
        displayHealthInsuranceModal(selectedEmployeeGroup.id),
      handleActiveToggle: () =>
        toggleActive(selectedEmployeeGroup.id, "healthInsuranceBenefit"),
      advanced: true,
      hasV2Screen: false,
    };

    if (insuranceProducts.length === 0) {
      cardProps.requestInfo = true;
      cardProps.advanced = false;
    }

    return cardProps;
  };

  return (
    <SplitTreatments
      names={[featureFlagsDictionary.BI_264]}
      attributes={{
        countryISOCode: country,
        benefit: BenefitCategory.HEALTH_INSURANCE,
      }}
    >
      {({ treatments }) => {
        const migratedHealthInsurance =
          treatments[featureFlagsDictionary.BI_264].treatment === "on";
        if (migratedHealthInsurance) return null;

        const cardProps = buildCardProps();
        return <BenefitCard {...cardProps} />;
      }}
    </SplitTreatments>
  );
};

export default HealthInsuranceCard;
